import { FastApiAxiosInstance } from 'common/service/axiosInstances';
import { WorkStyleDimension, WorkStyleType, RelationGame } from 'common/types';

const workV2 = {
  // 获取任务所需作品风格
  getWorkStyleDimensionList: () => {
    return FastApiAxiosInstance.get<{ total: number; items: WorkStyleDimension[] }>('api/v2/work/style/dimension/list');
  },
  // 获取任务所需作品风格
  getWorkStyleList: () => {
    return FastApiAxiosInstance.get<{ total: number; items: WorkStyleType[] }>('/api/v2/work/style/list');
  },
  // 获取所有作品关联游戏
  getAllRelationGames: () => {
    return FastApiAxiosInstance.get<{ total: number; items: RelationGame[] }>('/api/v2/work/style/game/list');
  },
  // 获取热门的作品关联游戏
  getHotRelationGames: () => {
    return FastApiAxiosInstance.get<{ total: number; items: RelationGame[] }>(
      '/api/v2/work/style/game/quickOptionLists',
    );
  },
};

export default workV2;
